module.exports = __webpack_public_path__ + "deb2735d06468c1cfde08830c4435ec7.svg";